import { Typography, Box, useTheme, Stack, IconButton, Card, Divider } from "@mui/material";
import ArrowBack from '@mui/icons-material/ArrowBack';
import Close from '@mui/icons-material/Close';

import { tokens } from "../theme/theme";
const HeaderBold = ({ title, subtitle, callback }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const call_backprocess = () => {
    callback();
  }

  return (
    <Box>
      {/* <Divider /> padding: "10px", */}
      <Box sx={{  marginLeft: "10px",marginBottom:"5px" }} display="flex" justifyContent="space-between" alignItems="center">
        <Box marginTop={0} display="flex">
          <Typography variant="h4" color={colors.grey[100]} fontWeight="bold" >
            {title}
          </Typography>
          <Typography variant="h6" color={colors.greenAccent[400]}>
            {subtitle}
          </Typography>
        </Box>

        <div>
          <IconButton onClick={call_backprocess} >
            <Close  style={{ fontSize:"16px", color: "#2196F3" }} />
          </IconButton>
        </div>
      </Box>
    </Box>

  );
};

export default HeaderBold;




